import { DataLike } from "../DatagridAsync";
import { Col } from "./Col";

export type ColNumber<T extends DataLike = DataLike> = {
  colType: "number";
  field: string;
  headerName: string;
  editable?: boolean;
  validate?: (row: any, input: any) => string;
  filterable?: boolean;
  pin?: "left" | "right";
  unit?: string;
  sortable?: boolean;
  hide?: boolean;
  width?: number;
  resolve?: (data: T) => number;
};

export const isColNumber = (col: Col): col is ColNumber =>
  col.colType === "number";
